import React from 'react'
import { X } from 'react-feather'

import './index.scss'

/**
 * @param {Boolean} show - Defines modal visibility
 * @param {Function} onClose - Function to remove file
 * @param {String} title - Defines modal title
 * @param {Number} [modalWidth=452] - Defines modal width
 * @param {React.ReactElement} children - Component content
 * @param {React.ReactElement} renderFooter - Component footer
 * @param {React.ReactElement} renderHeader - Component footer
 * @param {String} backdropColor - Color of backdrop
 * @param {Object} customHeaderClass - Style properties for main section
 * @param {Object} customMainClass - Style properties for main section
 * @param {Object} customFooterClass - Style properties for main section
 *
 * @returns {React.ReactElement}
 */

function Modal({ show = false, onClose, title, modalWidth = 452, children, renderHeader, renderFooter, backdropColor, onCloseDisabled, customHeaderClass = "", customMainClass = "", customFooterClass = "" }) {

  const handleCloseModal = () => onClose && onClose()

  function returnClassNameClose() {
    let className = 'modal__container__close'

    if (onCloseDisabled) className += ' modal__container__close--disabled'

    return className
  }

  return (
    <div className={`modal ${show && 'modal--visible'}`} style={{ backgroundColor: backdropColor }}>
      <section className={`modal__container ${show && "modal__container--visible"}`} style={{ maxWidth: modalWidth }}>

        <header className={`modal__container__header ${customHeaderClass}`}>
          {title &&
            <div className="modal__container__title">
              <h1>{title}</h1>
            </div>
          }
          {renderHeader && renderHeader}
          {onClose && <X className={returnClassNameClose()} size={30} onClick={handleCloseModal} />}
        </header>

        <main className={`modal__container__main ${customMainClass}`}>
          {children}
        </main>

        {renderFooter &&
          <footer className={`modal__container__footer ${customFooterClass}`}>
            {renderFooter}
          </footer>
        }
      </section>
    </div>
  )
}

export default Modal
